import { FC, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import { IconButton } from '../../../../components/IconButton';
import { Filter } from '../../../../components/Icons/Filter';
import { PaddingBox } from '../../../../components/PaddingBox';
import { isNull } from '../../../../predicates/type';
import { syncManager } from '../../../../utils/syncManager';
import classes from './styles/listSidebarIndicatorButton.module.scss';
import { useListSidebarProvider } from './useListSidebarProvider';
import { getPortalContainer } from './utils';
import { ListFilterButtonCount } from './ListFilterButtonCount';

type ListSidebarIndicatorButton = {
	filtersCount?: number;
	disabled?: boolean;
};

export const ListSidebarIndicatorButton: FC<ListSidebarIndicatorButton> = ({ filtersCount = 0, disabled }) => {
	const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(getPortalContainer());
	const hasAppliedFilters = filtersCount > 0;
	const hasIndicator = hasAppliedFilters && filtersCount < 10;
	const hasCompactIndicator = hasAppliedFilters && filtersCount > 9;
	const { toggle } = useListSidebarProvider();

	useEffect(() => {
		syncManager.on('react', 'onListSidebarIndicatorPortalContainerRender', () => {
			const el = getPortalContainer();

			if (isNull(el)) {
				return;
			}

			setPortalContainer(el);
		});

		return () => {
			syncManager.off('react', 'onListSidebarIndicatorPortalContainerRender');
		};
	}, [portalContainer]);

	return (
		portalContainer &&
		ReactDom.createPortal(
			<PaddingBox rightSmall>
				<IconButton
					link
					className={classes.filterButton}
					onClick={toggle}
					aria-label='toggle filter'
					disabled={disabled}
				>
					<Filter />
					{(hasIndicator || hasCompactIndicator) && (
						<ListFilterButtonCount
							hasCompactIndicator={hasCompactIndicator}
							count={filtersCount}
							className={classes.listFilterButton}
						/>
					)}
				</IconButton>
			</PaddingBox>,
			portalContainer,
		)
	);
};
